import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { getJourneyFrontendBootAPI } from "./journeyFrontend.api";
import { IJourneyFrontendBootResponseSchema } from "./journeyFrontend.types";

type IGetJourneyFrontendBootService = { journeyId: string } & Omit<
  IGetAllServiceProps,
  "page" | "per_page" | "stage_id" | "filters"
>;

const useGetJourneyFrontendBootService = ({
  journeyId,
  enableQuery = true,
  cacheKeys = [],
}: IGetJourneyFrontendBootService) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.JOURNEY_FRONTEND_BOOT, journeyId, ...cacheKeys],
    queryFn: (): Promise<{ data: IJourneyFrontendBootResponseSchema }> =>
      getJourneyFrontendBootAPI({ journeyId }),
    enabled: enableQuery,
  });
};

export { useGetJourneyFrontendBootService };
